import { makeVar } from '@apollo/client';

const transNavId = makeVar<string>('');

export const GeneralApollo = {
  navTransactionId: transNavId,
};
